module.exports = __webpack_public_path__ + "img/Logo-17.4000596d.svg";